import React, { PureComponent } from "react";
import { Input, Select, Table, Checkbox, Button, Dialog } from "element-react";
import { Link } from "react-router-dom";
import download from "images/preferential/download.png";
import flowImg from "images/educationTraining/flowImg.png";
import './index.scss'


export default class TrainingGuide extends PureComponent {
  state = {
    value: "",
    dialogVisible: false
  };

  handleClick = () => {
    this.setState({
      dialogVisible: true
    })
  }

  render() {
    const { value, options } = this.state;
    const columns = [
      {
        type: "index",
        label: "序号",
        align: "center"
      },
      {
        label: "材料名称",
        prop: "name",
        align: "center"
      },
      {
        label: "材料要求",
        prop: "command",
        align: "center",
        render(row) {
          return <div style={{ color: "#18388c",cursor: 'pointer' }}>{row.command}</div>;
        }
      },
      {
        label: "原件",
        prop: "origin",
        align: "center"
      },
      {
        label: "复印件",
        prop: "copy",
        align: "center"
      },
      {
        label: "范本文件",
        prop: "file",
        align: "center",
        render(row) {
          return (
            <div style={{  display: 'flex',alignItems:'center',justifyContent:'center'}}>
              <img src={download} style={{ marginRight: '5px' }} />
              <span style={{cursor: 'pointer'}}>{row.file}</span>
            </div>
          );
        }
      }
    ];
    const dataSource = [
      {
        name: "优抚补贴申请表",
        command: "查看要求",
        upload: "",
        file: "范本",
        origin: "1",
        copy: "0"
      },
      {
        name: "伤残证",
        command: "查看要求",
        upload: "",
        file: "范本",
        origin: "0",
        copy: "1"
      },
      {
        name: "退役军人证",
        command: "查看要求",
        upload: "",
        file: "范本",
        origin: "0",
        copy: "1"
      },
      {
        name: "身份证",
        command: "查看要求",
        upload: "",
        file: "范本",
        origin: "0",
        copy: "1"
      }
    ];

    const textData = [
      "三亚市海棠区户籍；",
      "所申请人满足：伤残军人、三红、三属、在乡老复员军人、带病回乡退伍军人、参战退役军人等等其中一种条件，并持有对应的证件；",
      "所申请人还健在，未去世。"
    ];

    const flowData = [
      {
        title: "在线提交申请",
        text:
          "到户籍所在地退役军人服务中心大厅，选择优抚服务进行对应事项线下申请，并提交。"
      },
      {
        title: "受理审批",
        text: "由对应的退役军人事务处理中心受理审批。"
      },
      {
        title: "办结",
        text: "申请人可以于15个工作日后登陆系统进行查询办结状态。或到线下退役军人服务大厅进行查询办结结果。"
      }
    ];

    return (
      <div className="main_search_detail">
        <div className="center" style={{ marginTop: '0' }}>
          <div className="center_search">
            <div className="center_position_info"></div>
            <span style={{ color: "#18388c", fontSize: "24px" }}>
                 退役军人互联网应用培训_
            </span>
            <span style={{ lineHeight: "24px", color: "#18388c" }}>
                 办事指南
            </span>
          </div>
          <div className="application_info">
            <div className="application_info_title">
              <span style={{ marginLeft: "10px" }}>事项基本信息</span>
            </div>
          </div>
          <div className="application_info_table tabless">
            <table width="100%" border="1" cellPadding="0" cellSpacing="0">
              <tbody>
                <tr>
                  <td className="info_td_left">事项名称</td>
                  <td className="info_td_center">优抚补贴</td>
                  <td className="info_td_left">事项类型</td>
                  <td className="info_td_right">优抚服务</td>
                </tr>
                <tr>
                  <td className="info_td_left">面向对象</td>
                  <td className="info_td_center">
                    伤残军人、三红、三属、在乡老复员军人、带病回乡退伍军人、参战退役军人、涉核人员
                  </td>
                  <td className="info_td_left">办件业务系统</td>
                  <td className="info_td_right">海南退役军人一体化服务平台</td>
                </tr>
                <tr>
                  <td className="info_td_left">主管部门</td>
                  <td className="info_td_center">
                    海南省三亚市海棠区退役军人事务处
                  </td>
                  <td className="info_td_left">主管部门性质</td>
                  <td className="info_td_right">事业单位</td>
                </tr>
                <tr>
                  <td className="info_td_left">法定办结时限</td>
                  <td className="info_td_center">20（工作日）</td>
                  <td className="info_td_left">承诺办结时限</td>
                  <td className="info_td_right">15（工作日）</td>
                </tr>
                <tr>
                  <td className="info_td_left">申请类型</td>
                  <td className="info_td_center">承诺件</td>
                  <td className="info_td_left">办理形式</td>
                  <td className="info_td_right">窗口办理/网上办理</td>
                </tr>
                <tr>
                  <td className="info_td_left">费用</td>
                  <td className="info_td_center">免费</td>
                  <td className="info_td_left">中介服务</td>
                  <td className="info_td_right">无</td>
                </tr>
                <tr>
                  <td className="info_td_left">办件状态</td>
                  <td className="info_td_center">    <span style={{color: "#18388c"}}>已通过</span></td>
                  <td className="info_td_left">办件结果</td>
                  <td className="info_td_right">
                        <span style={{color: "#18388c",cursor: 'pointer'}}>办件结果下载</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="application_info">
            <div className="application_info_title">
              <span style={{ marginLeft: "10px" }}>申请条件</span>
            </div>
          </div>
          <div>
            <div className="application_price">
              <ul>
                {textData.map((item, index) => {
                  return (
                    <li>
                      {index + 1}
                      <span>、{item}</span>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>

          <div className="application_info">
            <div className="application_info_title">
              <span style={{ marginLeft: "10px" }}>申请办理流程</span>
            </div>
          </div>

          <div className="application_flow">
            <div style={{ marginBottom: "40px" }}>
              <div className="online_process_flow">网上办理流程：</div>
              <ul>
                {flowData.map((item, index) => {
                  return (
                    <li>
                      <div className="online_process_flow_title">
                        {index + 1}.<span>{item.title}</span>
                      </div>
                      <div className="online_process_flow_text">
                        {item.text}
                      </div>
                    </li>
                  );
                })}
              </ul>
              <Button onClick={() => this.handleClick()}>
                <span style={{ color: "#fff" }}>查看流程图</span>
              </Button>
            </div>
            <div style={{ marginBottom: "40px" }}>
              <div className="online_process_flow">网上办理流程：</div>
              <ul>
                {flowData.map((item, index) => {
                  return (
                    <li>
                      <div className="online_process_flow_title">
                        {index + 1}.<span>{item.title}</span>
                      </div>
                      <div className="online_process_flow_text">
                        {item.text}
                      </div>
                    </li>
                  );
                })}
              </ul>
              <Button onClick={() => this.handleClick()}>
                <span style={{ color: "#fff" }}>查看流程图</span>
              </Button>
            </div>
          </div>
          <div className="application_info">
            <div className="application_info_title">
              <span style={{ marginLeft: "10px" }}>材料清单</span>
            </div>
          </div>

          <div style={{ margin: "20px 19px 40px 19px " }}>
            <Table
              style={{ width: "100%" }}
              columns={columns}
              data={dataSource}
              border={true}
            />
          </div>

          <div className="application_info">
            <div className="application_info_title">
              <span style={{ marginLeft: "10px" }}>事项设定依据</span>
            </div>
          </div>
          <div className="application_set_item">
            <table width="100%" border="1" cellPadding="0" cellSpacing="0">
              <tbody style={{ fontSize: '14px' }}>
                <tr >
                  <td className="item_left">法律法规</td>
                  <td className="item_right">海棠区区办事处优抚补贴申请 工作实施方案</td>
                </tr>
                <tr>
                  <td className="item_left">依据问号</td>
                  <td className="item_right">桂海棠〔2018〕10号</td>
                </tr>
                <tr>
                  <td className="item_left">条款号</td>
                  <td className="item_right">第二条</td>
                </tr>
                <tr>
                  <td className="item_left">颁布机关</td>
                  <td className="item_right">海南省三亚市海棠区退役军人事务处</td>
                </tr>
                <tr>
                  <td className="item_left">实施日期</td>
                  <td className="item_right">2019-12-21</td>
                </tr>
                <tr>
                  <td className="item_left">条款内容</td>
                  <td className="item_right">凡在海南省三亚市海棠区居民，同时属于伤残军人、三红、三属、在乡老复员军人、带病回乡退伍军人、参战退役军人等的均适用本办法，享受相关补贴和优惠。</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {/* 当前位置 */}
        <Dialog
  
          visible={this.state.dialogVisible}
          onCancel={() => this.setState({ dialogVisible: false })}
        >
          <Dialog.Body style={{ textAlign:'center'}}>
            <img src={flowImg} style={{ borderTop: '2px solid #eee' ,textAlign:'center'}}/>
          </Dialog.Body>
        </Dialog>
      </div>

    );
  }
}
